module.exports = __webpack_public_path__ + "img/8.802e997d.jpg";